import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { filter, fromEvent, map, merge, Observable, take, timer } from 'rxjs';

/** After this long, a redirect that has not unloaded the page is treated as cancelled. */
export const ABANDONED_REDIRECT_TIMEOUT_MS = 15_000;

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectService {
  private document = inject(DOCUMENT);

  /**
   * Sends the browser to an identity provider. The returned observable emits
   * once if this page is still in use afterwards — the navigation was
   * cancelled or failed, or the page was restored from the back/forward
   * cache — so the caller can re-enable its form.
   */
  redirect(url: string): Observable<void> {
    const window = this.document.defaultView!;

    window.location.assign(url);

    return merge(
      fromEvent<PageTransitionEvent>(window, 'pageshow').pipe(
        filter(event => event.persisted)
      ),
      timer(ABANDONED_REDIRECT_TIMEOUT_MS)
    ).pipe(
      take(1),
      map(() => undefined)
    );
  }
}
